import StoryModule from '../components/StoryModule';

const DataStory = () => <StoryModule slug="data-story" />;

export default DataStory;
